import logo from 'assets/images/logo/aram-logo.png';

// ==============================|| LOGO SVG ||============================== //

export default function LogoMain() {
  return (
    <img src={logo} alt="Aram Plasters" width="140" />
  );
}
